// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Baa-z","fadeIn":"Caa-z","delay":"Daa-z","recommendedSizeTooltip":"Eaa-z"};